// extracted by mini-css-extract-plugin
export default {"title":"sCeuZwJl1j5spI1mibL1","footer":"hrAPoucGVV0X4FVLizPm","body":"wbQP7H2_KzLA8G1Met1g","submit":"XSaxVhoY9VWQH2DezzCX","review":"iXdfiuOGEFcQ0ZS0cjyc"};